import { claimNextSupportRequest } from './claimNextSupportRequest'
import { createPublicSupportRequest } from './createPublicSupportRequest'
import { createSupportRequest } from './createSupportRequest'
import { getDetailByNumber } from './getDetailByNumber'
import { getSupportReasons } from './getSupportReasons'
import { listSupportRequests } from './listAllSupport'
import { replySupportRequest } from './replySupportRequest'
import { updateSupportRequest } from './updateSupportRequest'
import { uploadSupportAttachments } from './uploadSupportAttachments'

export const supportRequestService = {
  listSupportRequests,
  getDetailByNumber,
  replySupportRequest,
  updateSupportRequest,
  claimNextSupportRequest,
  getSupportReasons,
  createSupportRequest,
  createPublicSupportRequest,
  uploadSupportAttachments,
}
